import Alert from '@mui/joy/Alert'

export const PrimaryAlert = ({ children }) => (
    <Alert size="sm" variant="soft" color="primary">
        {children}
    </Alert>
)
